import {useEffect, useRef, useState} from "react"
import {useIdleTimeoutContext} from "react-idle-timeout"
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import {removeToken, handleExpiredJwtSession} from "../utilities/useToken"
import {wrappedPost} from "../utilities/AxiosHelper"

const BLOCKED_EVENTS = ["mousemove", "mousedown", "mouseup", "click", "dblclick", "keydown", "keyup"]
const ACTION_SELECTOR = '[data-timeout-modal-action="true"]'

function TimeoutWarning() {
    const {isWarning, remainingTime, reset} = useIdleTimeoutContext()
    const modalContentRef = useRef(null)
    const [busy, setBusy] = useState(false)

    // While the warning is showing, swallow all page activity so it can't
    // silently reset the idle timer. Only the modal's own buttons get through.
    useEffect(() => {
        if (!isWarning) {
            return
        }

        const blockEvent = (event) => {
            const insideAction = event.target?.closest?.(ACTION_SELECTOR)
            // Let clicks and keyboard activation (Enter/Space/Tab) reach the buttons
            if (insideAction && ["click", "keydown", "keyup"].includes(event.type)) {
                return
            }

            event.stopPropagation()
            event.preventDefault()
        }

        BLOCKED_EVENTS.forEach((event) => document.addEventListener(event, blockEvent, true))

        return () => {
            BLOCKED_EVENTS.forEach((event) => document.removeEventListener(event, blockEvent, true))
        }
    }, [isWarning])

    const formatRemainingTime = (seconds) => {
        const mins = Math.floor(seconds / 60)
        const secs = seconds % 60
        const secsStr = mins === 0 ? String(secs) : String(secs).padStart(2, "0")

        if (mins === 0) {
            return `${secsStr} second${secs === 1 ? "" : "s"}`
        }

        return `${mins}:${secsStr} minute${mins === 1 ? "" : "s"}`
    }

    const stayLoggedIn = () => {
        setBusy(true)
        wrappedPost("/update-token")
            .then(() => reset())
            .catch(() => handleExpiredJwtSession())
            .finally(() => setBusy(false))
    }

    const logout = () => {
        setBusy(true)
        wrappedPost("/logout")
            .catch(() => {})
            .finally(() => {
                removeToken()
                window.location.replace("/login")
            })
    }

    return (
        <Modal show={isWarning} backdrop="static" keyboard={false} ref={modalContentRef}>
            <Modal.Header className="badge-light-warning">
                <Modal.Title className="badge-light-warning">Session Timeout</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Your session will expire in {formatRemainingTime(remainingTime)}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" data-timeout-modal-action="true" disabled={busy} onClick={stayLoggedIn}>
                    Stay Logged In
                </Button>
                <Button variant="danger" data-timeout-modal-action="true" disabled={busy} onClick={logout}>
                    Logout
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default TimeoutWarning